import { Routes, Route } from "react-router-dom";
import Ecwid from "./Ecwid";
import Home from "./Components/Home";
import Footer from "./Components/Footer";
import Header from "./Components/Header";
import Cart from "./Components/cart";
import Payment from "./Components/payment";
import SignUp from "./Components/SignUp";
import SignIn from "./Components/SignIn";
import ForgotPassword from "./Components/ForgotPassword";
import YourOrders from "./Components/YourOrders";
import CheckoutPage from "./Components/CheckoutPage";
import PaymentProcess from "./Components/PaymentProcess";
import { useCart } from "./context/CartContext";
import { useState} from "react";
import { useLocation } from "react-router-dom";
import OrderDetails from "./Components/OrderDetails";
import ProductDetails from "./Components/ProductDetails";
import MyProfile from "./Components/MyProfile";
import "./App.css"

const App = () => {
  const { cartItems } = useCart();
  const location = useLocation();
  
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  
  const isProductPage = location.pathname === '/Ecwid';
  
  // Define routes where Header and Footer should not be shown
  const hideLayoutRoutes = ['/SignIn', '/SignUp', '/ForgotPassword'];

  return (
    <>
      {!hideLayoutRoutes.includes(location.pathname) && (
        <Header cartItems={cartItems} toggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen} isProductPage={isProductPage} />
      )}
      
      <Routes>
        <Route path="/" element={<Home toggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen} />} />
        <Route path="/Ecwid" element={<Ecwid toggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen}/>}  />
        <Route path="/cart" element={<Cart />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/SignUp" element={<SignUp />} />
        <Route path="/SignIn" element={<SignIn />} />
        <Route path="/ForgotPassword" element={<ForgotPassword />} />
        <Route path="/YourOrders" element={<YourOrders />} />
        <Route path="/order-details/:orderId" element={<OrderDetails />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/payment/:paymentId" element={<PaymentProcess />} />
        <Route path="/product/:productId" element={<ProductDetails />} />
        <Route path="/MyProfile" element={<MyProfile/>}/>
      </Routes>
      
      {!hideLayoutRoutes.includes(location.pathname) && <Footer />}
    </>
  );
};

export default App;